export enum HttpStatusCode {
  Ok = 200,
  Accepted = 203,
  Created = 201,
  No_Response = 204,
  Forbidden = 403,
  Un_Authorized = 401,
}
